import {
  history,
  isRouteProducts,
  navigate,
  replace,
} from './history';

export const BULK_MEDIA_HASH = '#bulk-media';

export function toLocationHash(hash) {
  if (!hash) return '';
  const value = String(hash).replace(/^#/, '');
  return value ? `#${value}` : '';
}

export function hasBulkMediaHash(location) {
  if (location == null) return false;
  const hash = typeof location === 'string' ? location : location.hash;
  return toLocationHash(hash) === BULK_MEDIA_HASH;
}

export function isBulkMediaViewLocation({
  pathname,
  hash,
  selectionCount,
  selectionSource,
} = {}) {
  const minCount = selectionSource === 'search' ? 1 : 2;
  return isRouteProducts(pathname)
    && hasBulkMediaHash({ hash })
    && Number(selectionCount) >= minCount;
}

function currentLocationWithHash(hash) {
  const { pathname, search } = history.location;
  return {
    pathname,
    search,
    hash: toLocationHash(hash),
  };
}

export function pushBulkMediaHash() {
  navigate(currentLocationWithHash(BULK_MEDIA_HASH));
}

export function pushClearBulkMediaHash() {
  navigate(currentLocationWithHash(''));
}

export function replaceClearBulkMediaHash() {
  replace(currentLocationWithHash(''));
}
